<template>
  <div class="section">
    <div class="max-width">
      <div class="benefits">

        <div class="section__head section__head_middle">
          <div class="section__subheading fadeIn">Launch a Store</div>
          <h2 class="section__title">That Converts</h2>
          <div class="section__text">Build a stunning, high-performance store from the ground up in just a single afternoon.</div>
        </div>

        <div class="benefits__grid">
          <div
              class="benefits__item fadeIn"
              v-for="(benefit, index) in benefits"
              :key="index"
          >
            <div class="benefits__icon">
              <component :is="benefit.icon" />
            </div>
            <div class="benefits__about">
              <h3 class="benefits__title">{{ benefit.title }}</h3>
              <div class="benefits__text">{{ benefit.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconBenefitsMoney from '@/components/icons/IconBenefitsMoney.vue'
import IconBenefitsCart from '@/components/icons/IconBenefitsCart.vue'
import IconBenefitsOptions from '@/components/icons/IconBenefitsOptions.vue'
import IconBenefitsSupport from '@/components/icons/IconBenefitsSupport.vue'

const benefits = [
  {
    title: "Sales Optimization Features",
    text: "Every theme comes equipped with powerful, sales-focused features designed to boost conversions, streamline your workflow, and help you sell more with ease.",
    icon: IconBenefitsMoney,
  },
  {
    title: "Conversion-Driven Design",
    text: "Designs built to sell: every element designed and strategically placed to maximize user engagement, simplify navigation, guide actions, and drive higher conversions.",
    icon: IconBenefitsCart,
  },
  {
    title: "Customization Options",
    text: "Built-in customization features make it simple to adapt your store’s design and functionality, giving you full control to create a cohesive brand identity that resonates with your customers.",
    icon: IconBenefitsOptions,
  },
  {
    title: "Professional & Fast Support — 24/7",
    text: "Receive a response to your request within 15 minutes — anytime, day or night, weekday or weekend. Our team is available 24/7, even if you’re on a trial.",
    icon: IconBenefitsSupport,
  },
]
</script>

<style lang="scss">
.benefits {
  .section__head {
    max-width:800px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;

    @include xs {
      grid-template-columns: 1fr;
    }
  }

  &__item {
    border-radius: 24px;
    background: var(--color-gray-light);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2.5rem;
    min-height: 380px;
    gap: 3rem;

    @include md {
      padding:2rem;
    }

    @include xs {
      min-height: initial;
      padding: 1.5rem;
    }
  }

  &__icon {
    @include xs {
      svg {
        width: 48px;
        height: 48px;
      }
    }
  }

  &__title {
    font-size: 1.5rem;
    font-family: var(--font-family);
    margin: 0 0 0.5rem;
    font-weight: 900;
    line-height: 1.3;
    letter-spacing: -0.01em;
    text-transform: uppercase;

    @include md {
      font-size: 1.25rem;
    }
  }

  &__text {
    max-width: 600px;

  }
}
</style>
